import React, { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useLocalStorageOrder } from "../../hooks/useLocalStorageOrder.js";
import Navbar from "../../Components/Navbar";
import classes from "./Orders.module.css";

export const categories = [
  {
    id: "flowers",
    name: "פרחים",
    description:
      "פרחים טריים ואיכותיים – מושלמים לזרים, אירועים ועיצובים מרהיבים",
    icon: "🌹",
  },
  {
    id: "greenery",
    name: "ירוקים",
    description:
      "ענפים וירוקים משלימים – להוספת נפח, עומק ומראה טבעי לכל סידור",
    icon: "🌿",
  },
  {
    id: "plants",
    name: "צמחים",
    description: "צמחים בעציצים – פתרון ירוק ועמיד לבית, למשרד או כמתנה מושלמת",
    icon: "🪴",
  },
  {
    id: "driedFlowers",
    name: "פרחים יבשים",
    description: "פרחים יבשים מעוצבים – ליופי שנשאר לאורך זמן, ללא תחזוקה",
    icon: "🌾",
  },
  {
    id: "accessories",
    name: "אביזרים",
    description: "כל מה שצריך לעיצוב מושלם – סרטים, חוטים וקישוטים ברמה גבוהה",
    icon: "🎀",
  },
  {
    id: "floralTools",
    name: "כלים",
    description: "ציוד מקצועי לעבודה עם פרחים – נוחות, דיוק ותוצאות ברמה גבוהה",
    icon: "✂️",
  },
];

export default function Orders() {
  const location = useLocation();
  const isMainPage = location.pathname === "/orders";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useLocalStorageOrder();

  // אם אנחנו בדף משנה, הצג אותו
  if (!isMainPage) {
    return (
      <>
        <Navbar />
        <Outlet />
      </>
    );
  }

  // דף ראשי
  return (
    <div>
      <Navbar />
      <div className={classes.ordersContainer}>
        <div className={classes.headerSection}>
          <h1 className={classes.mainTitle}>הזמנות בסיטונאות</h1>
          <div className={classes.subtitle}>
            בחרו קטגוריה, הוסיפו מוצרים לעגלה ושלחו <br className={classes.subtitleNewLine} /> בקשת הזמנה 🌸
            <p>✔ ללא חיוב באתר </p>
            <p>✔ בדיקת זמינות מלאה לפני אישור</p>
            <p>✔ שירות אישי ומהיר</p>
            לאחר שליחת הבקשה ניצור איתכם קשר <br className={classes.subtitleNewLine}/> לאישור סופי ותשלום.
          </div>
        </div>

        <div className={classes.categoriesGrid}>
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.id}
              className={classes.categoryLink}
            >
              <div className={classes.categoryCard}>
                <div className={classes.categoryContent}>
                  <div className={classes.categoryIcon}>{category.icon}</div>
                  <h2 className={classes.categoryName}>{category.name}</h2>
                  <p className={classes.categoryDescription}>
                    {category.description}
                  </p>
                </div>
                <div className={classes.categoryActions}>
                  <button className={classes.categoryButton}>
                    בחר קטגוריה זו
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
